<script setup>
import { watch } from 'vue';
import Sidebar from './Sidebar.vue';
import Topbar from './Topbar.vue';
import { Alert, MediaUploaderModal } from '@components';
import { mediaUploader } from '@utils/mediaUploader';
import Prompt from '@components/Prompt.vue';
import { isLg, isXl } from '@utils/mediaQuery';

import { useGeneral } from '@store/general';
const { sidebarOptions } = useGeneral();

import { useRoute } from 'vue-router';
const route = useRoute();

watch(route, (to, from) => {
    if (to.name !== from.name) {
        mediaUploader.selectImage('undefined');
    }
});

import { useSettings } from '@store/settings';
const $settings = useSettings();
</script>

<template>
<div class="min-h-screen overflow-y-auto overflow-x-hidden">
    <Alert class="fixed top-3 right-5" />
    <Prompt />

    <div>
        <Sidebar />
        <Topbar />
    </div>
    <main class="my-[60px] mx-5"
        :style="[(isLg || isXl) && !$settings.isRTL ? `padding-left:${sidebarOptions.sidebarWidth}` : `padding-right:${isLg || isXl ? sidebarOptions.sidebarWidth : '0px'}`]">
        <router-view v-slot="{ Component }">
            <component :is="Component"></component>
        </router-view>

    </main>

    <div class="overflow-y-scroll">
        <MediaUploaderModal />
    </div>
</div>
</template>